import React, {Component} from 'react';
import PropTypes from 'prop-types';

export default class RWBLogoVertical extends Component {
  render() {
    const {className, width, height, fullWidth} = this.props;
    return (
      <svg
        className={className}
        viewBox="0 0 138.1 130"
        width={fullWidth ? '100%' : width}
        height={height}>
        <g id="prefix__Layer_2" data-name="Layer 2">
          <g id="prefix__Art">
            <path
              fill="#041E42"
              className="prefix__cls-1"
              d="M31.71 119.61h2.06c2.17 0 3.85-.37 5-1.35a4.37 4.37 0 0 0 1.3-1.89 7.63 7.63 0 0 0 .41-2.64v-6.45a7.59 7.59 0 0 0-.41-2.64 4.34 4.34 0 0 0-2.28-2.51 9.32 9.32 0 0 0-4-.73H10.23a.59.59 0 0 0-.4.16.57.57 0 0 0-.16.39v23c.2 3.61 1.43 4.77 4.33 5.1h2.51a.55.55 0 0 0 .56-.56v-22.24H30.9a3.54 3.54 0 0 1 1.86.32.86.86 0 0 1 .33.41 2.48 2.48 0 0 1 .13.9v3.3a2.48 2.48 0 0 1-.13.9.92.92 0 0 1-.6.55 5.19 5.19 0 0 1-1.59.18h-8.43v3.48c.27 2.16 1 3.34 3.08 5.2a7.82 7.82 0 0 1 1 1l6.78 6.36a.54.54 0 0 0 .38.15h9.16a.56.56 0 0 0 .53-.37.55.55 0 0 0-.18-.62zM91.49 101.4h-5.7a.55.55 0 0 0-.52.36l-6.17 17.07-6.91-17.09a.56.56 0 0 0-.52-.34h-4.48a.54.54 0 0 0-.51.35l-6.77 17.1-6.47-17.09a.55.55 0 0 0-.52-.36h-6.61a.57.57 0 0 0-.46.24.55.55 0 0 0-.06.51l10.6 27.5a.57.57 0 0 0 .52.35h4.42a.56.56 0 0 0 .52-.35L69 111.92l7.06 17.73a.54.54 0 0 0 .51.35h4.32a.57.57 0 0 0 .52-.35L92 102.15a.55.55 0 0 0-.06-.51.57.57 0 0 0-.45-.24zM127 116.59a5.64 5.64 0 0 0-1.88-1.3 5.26 5.26 0 0 0 1.69-1.08 4.78 4.78 0 0 0 1.4-3.57v-3.36a7.59 7.59 0 0 0-.41-2.64 4.34 4.34 0 0 0-2.28-2.51 9.32 9.32 0 0 0-4-.73H97.94a.59.59 0 0 0-.4.16.57.57 0 0 0-.16.39v27.49a.55.55 0 0 0 .56.56h21.84c2.75 0 4.87-.42 6.37-1.4a4.9 4.9 0 0 0 1.72-1.9 5.86 5.86 0 0 0 .56-2.64v-3.51a5.63 5.63 0 0 0-1.43-3.96zm-5.65 5.41a2.79 2.79 0 0 1-.14 1 1 1 0 0 1-.65.65 5 5 0 0 1-1.74.2h-14V107h14a4 4 0 0 1 1.92.31.82.82 0 0 1 .33.36 1.73 1.73 0 0 1 .12.75V111a1.76 1.76 0 0 1-.12.75 1 1 0 0 1-.63.49 5.51 5.51 0 0 1-1.62.18h-8.62v1.5c.31 2.9 1.48 3.84 3.9 4.14h4.72a6.7 6.7 0 0 1 1.3.09 1.32 1.32 0 0 1 .94.47 2.15 2.15 0 0 1 .29 1.33zM88.24 43.07L75 43.71l-5.9-12-.1-.28L0 10.89c.15 8.24 7.64 21.61 17.5 23.19l46.82 7.31-1 2.13-46.47-1.17c.61 8.44 9.7 14 16.12 13.69l26.47-1.17.08.09-.44 2.54L32.9 63c3.71 6.31 16.86 9.45 19.6 7.65l7.13-3.77 9.46-5 11.84 6.22L78.66 55z"
            />
            <path
              fill="#BF0D3E"
              className="prefix__cls-2"
              d="M72.23 30.53L77 40.27l5.79-.27 37.82-5.91c9.56-1.42 17.34-14.95 17.49-23.19zM90.84 45.16l-8 9.9 22.25 1c5.86.23 15.51-5.25 16.12-13.69l-28.74.73zM84.22 67.58l.44 2.6.94.49c2.75 1.8 15.89-1.34 19.61-7.65l-22.59-4.76z"
            />
            <path
              fill="#041E42"
              className="prefix__cls-1"
              d="M88.54 7.6A28.21 28.21 0 0 0 82 4.17S80.15.88 74.74.25c-8.32-1-12.87.76-17.37 6.19s-4.88 16.18-4.88 16.18L69.37 28l12-3.67a8.05 8.05 0 0 1-1.2-3.33c-.48-2.42-.68-4.76.36-6.25a11.28 11.28 0 0 1 2-2.22s1.56.36 2.21.44l2.19.29a4.87 4.87 0 0 1 .17 2.55c-.14.41.73.47 1.42-.55s3.13-5.36.02-7.66zm-9.45.45c-.58 1.11-1.42 2-3.55 1.4C73.69 8.9 74 6 74 6l5.82 1.12a4.79 4.79 0 0 0-.73.93z"
            />
            <path
              fill="#BF0D3E"
              className="prefix__cls-2"
              d="M45.64 86.9l-.58 1.81h2.44V94c.08.9.46 1.51 2 1.51h.11v-6.8h2.53V86.9zM60.21 91.91H63l-.53-1.71h-2.26v-1.58h3.26V86.9h-5.35v6.82c0 1 .34 1.76 2.05 1.76h3.44v-1.71h-3.4zM72.24 86.86l-3.09 8.64h2.08l.57-1.78h3l.61 1.79h2.2l-3-8.65zm.07 5.19l1-3 1 3zM90.79 94.26c.14.74.6 1.22 2 1.22H93l-.62-8.58h-2.64l-1.68 5.92-1.68-5.92h-2.75l-.48 6.66c0 1 .24 1.79 1.72 1.89l.37-5.67 1.62 5.71h2.01l1.63-5.73zM108.57 68h-1.14v3.17H107V68h-1.18v-.4h2.75zm2.51 2.45l1.1-2.82h.73v3.54h-.42V68l-1.28 3.17h-.26l-1.3-3.17v3.17h-.43V67.6h.73z"
            />
          </g>
        </g>
      </svg>
    );
  }
}

RWBLogoVertical.defaultProps = {
  width: 24,
  height: 24,
};

RWBLogoVertical.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
